
import { Instagram, Facebook } from "lucide-react";
import { useTranslation } from "react-i18next";

const SocialLinks = () => {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">
        {t("settings.social.title")}
      </h3>
      <div className="flex space-x-4">
        <a
          href="https://www.instagram.com/checkmytrip"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-travel-500"
        >
          <Instagram className="h-6 w-6" />
        </a>
        <a
          href="https://www.facebook.com/CheckmytripbyAmadeus"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-travel-500"
        >
          <Facebook className="h-6 w-6" />
        </a>
      </div>
    </div>
  );
};

export default SocialLinks;
